import * as React from 'react';
// import { Space, TimePicker } from 'antd';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { Padding } from '@mui/icons-material';
import { InputLabel } from '@mui/material';
import dayjs from 'dayjs';


export default function TimeRanges(props) {
  let currentDate = new Date()
  const currentDay = currentDate.getUTCDate();
  const currentMonth = currentDate.getUTCMonth(); // Months are zero-based, so we add 1
  const currentYear = currentDate.getUTCFullYear();
  const [toTime, setToTime] = React.useState('')
  const [fromTime, setFromToTime] = React.useState('')

  React.useEffect(() => {

    let date = `${currentYear}-${currentMonth}-${currentDay}`
     setFromToTime(dayjs(`${date}T${convertToIST(props.tsHours,props.tsMinutes).istHour}:${convertToIST(props.tsHours,props.tsMinutes).istMinute}`))
    //  setToTime(dayjs(`${date}T${convertToIST(props.endHours,props.endMinutes).istHour}:${convertToIST(props.endHours,props.endMinutes).istMinute}`))

  }, [])

  const changeToTime = (newTime) => {
    const formattedHour = newTime ? newTime.$H : 0;
    const formattedMinute = newTime ? newTime.$m : 0;
    setToTime(newTime)
    props.onChange({ "hour": convertToUTC(formattedHour,formattedMinute).utcHour, "minute": convertToUTC(formattedHour,formattedMinute).utcMinute, "type": "fromtime" })

  }

  const changeFromTime = (newTime) => {
    setFromToTime(newTime)
    const formattedHour = newTime ? newTime.$H : 0;
    const formattedMinute = newTime ? newTime.$m : 0;
    props.onChange({ "hour": convertToUTC(formattedHour,formattedMinute).utcHour, "minute": convertToUTC(formattedHour,formattedMinute).utcMinute, "type": "totime" })

  }

  function convertToUTC(istHour, istMinute) {
    // Create a new Date object with ISO time
    var localDate = new Date();
    localDate.setHours(istHour);
    localDate.setMinutes(istMinute);

    // Get the UTC values of hour and minute
    var utcHour = localDate.getUTCHours();
    var utcMinute = localDate.getUTCMinutes();

    return { utcHour, utcMinute };
}

function convertToIST(utcHour, utcMinute) {
  // Create a new Date object with the current UTC time
  var utcDate = new Date();
  utcDate.setUTCHours(utcHour);
  utcDate.setUTCMinutes(utcMinute);

  // Get the offset for IST (Indian Standard Time), which is UTC+5:30
  var istOffset = 5.5 * 60 * 60 * 1000; // Convert 5 hours 30 minutes to milliseconds

  // Convert UTC time to IST by adding the offset
  var istTime = new Date(utcDate.getTime())

  // Extract IST hour and minute
  var istHour = istTime.getHours();
  var istMinute = istTime.getMinutes();

 

  return {istHour , istMinute };
}


  return (
    //   <Space direction="vertical">
    //   <TimePicker.RangePicker status="warning" />
    // </Space>
  
    <div>
      <InputLabel className='__Input-label' id="label">Time</InputLabel>
      <LocalizationProvider className="timeslot" dateAdapter={AdapterDayjs} >
        <DemoContainer components={['TimePicker', 'TimePicker']} >
          {/* <div > */}
          <TimePicker
            className='from-timepicker'
            label="From"
            viewRenderers={{
              hours: renderTimeViewClock,
              minutes: renderTimeViewClock,
              seconds: renderTimeViewClock,
            }}
            value={fromTime}
            onChange={changeFromTime}
            ampm={false}
            views={['hours', 'minutes']}
          /> 
          {/* <TimePicker
            className='to-timepicker'
            label="To"
            viewRenderers={{
              hours: renderTimeViewClock,
              minutes: renderTimeViewClock,
              seconds: renderTimeViewClock,
            }}
            value={toTime}
            onChange={changeToTime}
            ampm={false}
            views={['hours', 'minutes']}
          /> */}
          {/* </div> */}
        </DemoContainer>
      </LocalizationProvider>
    </div>
  );
}